<div class="root-div">
  @if (percentage) {
  <div class="font" pTooltip=" Complete {{ percentage }}" tooltipPosition="bottom">
    <div>{{ percentage }}</div>
  </div>
  }
</div>
